import React from "react";
import Image from "../image/Image";
import LinkWrapper from "../linkWrapper/LinkWrapper";

const HeroSlide = (props) => {
    const { link = {} } = props;

    return (
        <div className="single-slider slider-height-1 bg-purple">
            <div className="container">
                <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-6 col-12 col-sm-6">
                        <div className="slider-content slider-animated-1">
                            {props.eyebrow && <h3 className="animated">{props.eyebrow}</h3>}
                            {props.title && <h1 className="animated">{props.title}</h1>}

                            {link.label && (
                                <div className="slider-btn btn-hover">
                                    <LinkWrapper linkNode={props.link} linkClass="animated">
                                        {link.label}
                                    </LinkWrapper>
                                </div>
                            )}
                        </div>
                    </div>

                    {props.image && (
                        <div className="col-xl-6 col-lg-6 col-md-6 col-12 col-sm-6">
                            <div className="slider-single-img slider-animated-1">
                                <Image imageNode={props.image} className="animated img-fluid" />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default HeroSlide;
